import type { TripInstanceLiveProgress, TripInstanceLiveProgressStop } from "./types";

/**
 * The stop the bus is heading to: the first still-upcoming stop after the last
 * one it has actually reached. Anchoring on the last reached stop (rather than
 * the first "upcoming" anywhere) keeps a stop the bus passed without a check-in
 * from pinning "next stop" behind it for the rest of the trip.
 */
export function nextLiveStop(live: TripInstanceLiveProgress | null | undefined): TripInstanceLiveProgressStop | undefined {
  if (!live || live.stops.length === 0) return undefined;
  const stops = live.stops.slice().sort((a, b) => a.stop_sequence - b.stop_sequence);
  let lastReached = -1;
  stops.forEach((s, i) => { if (s.status !== "upcoming") lastReached = i; });
  return stops.slice(lastReached + 1).find((s) => s.status === "upcoming");
}

/** "Stop name · ETA 14:32 · 1.2 km", with whichever parts are known. */
export function describeNextStop(stop: TripInstanceLiveProgressStop | undefined): string | undefined {
  if (!stop) return undefined;
  const parts = [stop.stop_name];
  if (stop.predicted_arrival) {
    parts.push(`ETA ${new Date(stop.predicted_arrival).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}`);
  }
  if (stop.distance_remaining_m != null) {
    const m = stop.distance_remaining_m;
    parts.push(m >= 1000 ? `${(m / 1000).toFixed(1)} km` : `${Math.round(m)} m`);
  }
  return parts.join(" · ");
}
